import { defineMessages } from 'react-intl';

const messages: {
	emptyStateDescription: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	emptyStateHeader: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	starredEmptyStateDescription: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	starredEmptyStateHeader: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	emptyStateHeader: {
		id: 'navigation-global-side-navigation.object-list-flyout.empty-state.header',
		defaultMessage: 'Nothing to see here!',
		description: 'Message for the header of the default empty state in the object list flyout',
	},
	emptyStateDescription: {
		id: 'navigation-global-side-navigation.object-list-flyout.empty-state.description',
		defaultMessage:
			'Once you visit, edit, or create projects, issues, boards, filters, and dashboards, they’ll show up here.',
		description: 'Message for the description of the default empty state in the object list flyout',
	},
	starredEmptyStateHeader: {
		id: 'navigation-global-side-navigation.object-list-flyout.starred-empty-state.header',
		defaultMessage: "You haven't starred anything yet.",
		description: 'Message for the header of the starred empty state in the object list flyout',
	},
	starredEmptyStateDescription: {
		id: 'navigation-global-side-navigation.object-list-flyout.starred-empty-state.description',
		defaultMessage:
			'Mark items that are important to you with a star to quickly access them. You’ll see those items here.',
		description: 'Message for the description of the starred empty state in the object list flyout',
	},
});

export default messages;
